// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, saveSessionToken } from "@/lib/api";
import { useApp } from "@/context/AppContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useApp();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      const sessionId = match?.[1];
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        if (data?.session_token) saveSessionToken(data.session_token);
        setUser(data.user);
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch { navigate("/", { replace: true }); }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#F5F0E6] text-[#1A1610] flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#C5A880] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm tracking-[0.2em] uppercase text-[#C5A880]">Verifying access</p>
      </div>
    </div>
  );
}
